<template>
  <tbody>
    <template v-if="loading && !isDocumentContext">
      <tr
        v-for="i in 5"
        :key="i"
      >
        <td :colspan="colspan">
          <div class="w-full h-[34px] animate-pulse">
            <div class="flex items-center justify-between">
              <div>
                <div class="h-2.5 bg-gray-300 rounded-full w-24 mb-2.5" />
                <div class="w-32 h-2 bg-gray-200 rounded-full" />
              </div>
              <div class="h-2.5 bg-gray-300 rounded-full w-12" />
            </div>
          </div>
        </td>
      </tr>
    </template>

    <template v-else-if="noResults">
      <tr>
        <td
          class="no-results-table-body h-80 rounded-md"
          :colspan="colspan"
        >
          <p class="text-center mt-6 text-secondary-emphasis text-lg">
            {{ noResultsText ? noResultsText : 'There are no results' }}
          </p>
        </td>
      </tr>
    </template>

    <template v-else>
      <slot />
    </template>
  </tbody>
</template>

<script setup>
import { inject } from 'vue';

// tables dont need to load on the document view
const isDocumentContext = inject('isDocumentContext', false);

defineProps({
  loading: {
    type: Boolean,
    default: true,
  },
  noResults: {
    type: Boolean,
    default: false,
  },
  noResultsText: {
    type: String,
    default: '',
  },
  colspan: {
    type: Number,
    default: 1,
  },
});

</script>
